module.exports = __webpack_public_path__ + "static/assets/5a3b3f914c142cfe38b86afdb3221ddc.svg";